import React, { useEffect, useState } from "react";
import { useGetStoreOfAccountApi } from "../../hooks";
import {
  getKeyValue,
  ModalBody,
  ModalHeader,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  useDisclosure,
} from "@nextui-org/react";
import {
  AccountOfStore,
  FooterFilterMobile,
  MachineOfStore,
  ModelNext,
} from "../../components";
import { useAccountOfStore, useAccountStore, useAuthStore } from "../../store";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";

const MyStorePage = () => {
  const { allStoreOfAccount, isLoading } = useGetStoreOfAccountApi();
  const [store, setStore] = useState([]);
  const [page, setPage] = useState(1);
  const [storeSelect, setStoreSelect] = useState<any>();

  const { token } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  // state store
  const { setStoreId } = useAccountOfStore();

  const rowsPerPage = 10;

  // State model
  const {
    isOpen: isOpenDetailMember,
    onOpen: onOpenDetailMember,
    onOpenChange: onOpenChangeDetailMember,
    // onClose: __,
  } = useDisclosure();

  const {
    isOpen: isOpenDetailMachine,
    onOpen: onOpenDetailMachine,
    onOpenChange: onOpenChangeDetailMachine,
  } = useDisclosure();

  const pages = Math.ceil(store.length / rowsPerPage);

  const items = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;

    return store.slice(start, end);
  }, [page, store]);

  useEffect(() => {
    if (allStoreOfAccount?.data?.length > 0) {
      const storeConvert = allStoreOfAccount?.data?.map((item: any) => {
        return {
          id: item?.groupId,
          grade: item?.grade,
          groupPass: item?.groupPass,
          groupName: item?.groupName,
          groupPhone: item?.groupPhone,
        };
      });
      setStore(storeConvert);
    }
  }, [allStoreOfAccount, isLoading]);

  return (
    <div>
      {/* store */}
      <ModelNext
        isOpen={isOpenDetailMember}
        onOpen={onOpenDetailMember}
        onOpenChange={onOpenChangeDetailMember}
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-gray-600">
          Member of Store ({storeSelect?.groupName})
        </ModalHeader>
        <ModalBody>
          <AccountOfStore onOpenDetailMember={onOpenDetailMember} />
        </ModalBody>
      </ModelNext>

      {/* machine */}
      <ModelNext
        isOpen={isOpenDetailMachine}
        onOpen={onOpenDetailMachine}
        onOpenChange={onOpenChangeDetailMachine}
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-gray-600">
          Machine of Store ({storeSelect?.groupName})
        </ModalHeader>
        <ModalBody>
          <MachineOfStore />
        </ModalBody>
      </ModelNext>
      <div className="w-[100%] p-[16px] md:px-[0px] md:pb-2 font-semibold text-ok-travel-green mb-2 border-b-[1.5px] md:mb-4">
        <h3 className="uppercase max-md:mt-4 text-medium text-gray-600 md:text-md xl:text-xl">
          My Store
        </h3>
      </div>
      <div className="mt-4 h-[100%] px-[16px] md:px-[0px]">
        <Table
          className="h-screen"
          aria-label="Example table with client side pagination"
          bottomContent={
            <div className="flex w-full justify-center items-end">
              <Pagination
                isCompact
                showControls
                showShadow
                color="default"
                page={page}
                total={pages}
                onChange={(page) => setPage(page)}
              />
            </div>
          }
          classNames={{
            wrapper: "h-[80%]",
          }}
        >
          <TableHeader>
            <TableColumn key="id">Group Id</TableColumn>
            <TableColumn key="grade">Grade</TableColumn>
            <TableColumn key="groupPass">Group Pass</TableColumn>
            <TableColumn key="groupName">Group Name</TableColumn>
            <TableColumn key="groupPhone">Group Phone</TableColumn>
            <TableColumn key="machine">Machine</TableColumn>
            <TableColumn key="member">Member</TableColumn>
          </TableHeader>
          <TableBody items={items}>
            {(item: any) => (
              <TableRow key={item.groupId}>
                {(columnKey) => {
                  if (columnKey === "member") {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        <span
                          onClick={() => {
                            onOpenDetailMember();
                            setStoreId(item?.id);
                            setStoreSelect(item);
                          }}
                          className="cursor-pointer"
                        >
                          Detail
                        </span>
                      </TableCell>
                    );
                  } else if (columnKey === "machine") {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        <span
                          onClick={() => {
                            onOpenDetailMachine();

                            setStoreId(item?.id);
                          }}
                          className="cursor-pointer"
                        >
                          Detail
                        </span>
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        {getKeyValue(item, columnKey)}
                      </TableCell>
                    );
                  }
                }}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </div>
  );
};

export default MyStorePage;
